import { render, staticRenderFns } from "./LSidebar.vue?vue&type=template&id=0d5073cf&scoped=true&"
import script from "./LSidebar.vue?vue&type=script&lang=js&"
export * from "./LSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LSidebar.vue?vue&type=style&index=0&id=0d5073cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5073cf",
  null
  
)

export default component.exports